var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70711 1.00203C6.31658 0.611504 5.68342 0.611504 5.29289 1.00203L0.705384 5.58954C0.315811 5.97911 0.315811 6.61073 0.705384 7.00031C1.09466 7.38958 1.72569 7.38992 2.11538 7.00107L5.29366 3.82972C5.68401 3.44022 6.31599 3.44022 6.70634 3.82972L9.88462 7.00108C10.2743 7.38992 10.9053 7.38958 11.2946 7.00031C11.6842 6.61073 11.6842 5.97911 11.2946 5.58954L6.70711 1.00203Z",
    fill: "#113D18"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.b17372f7.svg";
export { ForwardRef as ReactComponent };